import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PendingTransactionPage } from './pending-transaction';

@NgModule({
  declarations: [
    PendingTransactionPage,
  ],
  imports: [
    IonicPageModule.forChild(PendingTransactionPage),
  ],
})
export class PendingTransactionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/pending-transaction/pending-transaction.module.ts